const prettifier = str => str
  .replaceAll("Decimal('", '')
  .replaceAll("')", '')
  .replaceAll('None', 'null')
  .replaceAll('False', 'false')
  .replaceAll('True', 'true')
  .replaceAll('\'', '"')

const getConfig = () => JSON.parse(prettifier(window.config_temporary_data))

const STYLIZATION_KEY = 'stylization'

export const getCurrentConfig = key => {
  const config = getConfig()
  if (config[STYLIZATION_KEY] && config[STYLIZATION_KEY].type === key) {
    return config[STYLIZATION_KEY]
  }
  return null
}

export const isConfigAllowed = key => {
  const config = getCurrentConfig(key)
  if (!config) {
    return false
  }
  if (config.restriction && 'True' === window.isSuperUser) {
    return true
  }
  if (!config.restriction) {
    return true
  }
  return false
}

const HALLOWEEN_KEY = 'halloween'
const HALLOWEEN_CLASSNAME = 'is-halloween'

const NEW_YEAR_KEY = 'new_year'
const NEW_YEAR_CLASSNAME = 'is-new-year'

const createConfig = (key, classname, ids) => {
  const allowed = isConfigAllowed(key)
  if (!allowed) return
  ids.forEach(id => {
    const element = document.getElementById(id)
    if (!element) return
    element.classList.add(classname)
  })
}
const createHalloweenConfig = () => {
  createConfig(HALLOWEEN_KEY, HALLOWEEN_CLASSNAME, ['header'])
}
const createNewYearConfig = () => {
  createConfig(NEW_YEAR_KEY, NEW_YEAR_CLASSNAME, ['header', 'desktop-hover', 'sales-decor'])
}

const createDecor = () => {
  createHalloweenConfig()
  createNewYearConfig()
}

export default createDecor
